import React from 'react';
import { Skeleton } from '@mui/material';
import { DTableBodyRow } from './d-table-body-row';
import { DTableBodyCell } from './d-table-body-cell';

interface IDTableSkeletonRowsProps {
    // Number of columns to fill — pass the table's column count so the skeleton
    // mirrors the real row shape.
    columns: number;
    // How many placeholder rows to draw. A handful reads as "a list is coming"
    // without pretending to know the real page size.
    rows?: number;
}

/**
 * Placeholder rows for a loading table. Drop inside a DTableBody in place of the
 * real rows while the query is in flight, so the layout (column count, row
 * height) is reserved instead of collapsing to a spinner. Each cell is a text
 * Skeleton; widths vary a little so it doesn't look like a grid of identical bars.
 */
export function DTableSkeletonRows({ columns, rows = 5 }: IDTableSkeletonRowsProps) {
    return (
        <>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <DTableBodyRow key={rowIndex} alternate={rowIndex % 2 === 1}>
                    {Array.from({ length: columns }).map((__, colIndex) => (
                        <DTableBodyCell key={colIndex}>
                            <Skeleton
                                variant={'text'}
                                width={`${60 + ((colIndex * 17) % 35)}%`}
                            />
                        </DTableBodyCell>
                    ))}
                </DTableBodyRow>
            ))}
        </>
    );
}
